module.exports = __webpack_public_path__ + "img/thumb-bleekselderijrisotto.d00bdf5b.jpg";